import { asset$, assetState$ } from 'modules/asset/asset$';
import { auth$ } from 'modules/auth/stream/auth$';
import { course$ } from 'modules/course/course$';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export default combineLatest([auth$, asset$, assetState$, course$]).pipe(
  map(([{ user }, { byId }, { state }, courses]) => ({
    user,
    byId,
    state,
    news: Object.values(byId).filter(e => e.type === 'news').sort((a, b) => b.createdAt - a.createdAt),
    courses: Object.values(courses.byId).sort(
      (a, b) => (+new Date(a.createdAt) - +new Date(b.createdAt)) * -1
    ),
    pages: Object.values(byId).filter(e => e.type !== 'news')
  }))
);
